import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import React from 'react';
import { FiasLocaleHelper } from '../locale';
import { FiasComboBox } from '../Form/FiasComboBox';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { filterProps } from '@skbkontur/react-ui/lib/filterProps';
import { FiasAddress } from '..';
var COMBOBOX_PASS_PROPS = {
  limit: true,
  align: true,
  searchOnFocus: true,
  drawArrow: true,
  autoFocus: true,
  borderless: true,
  disablePortal: true,
  disabled: true,
  error: true,
  maxLength: true,
  menuAlign: true,
  onBlur: true,
  onFocus: true,
  onInputValueChange: true,
  placeholder: true,
  size: true,
  warning: true,
  width: true,
  maxMenuHeight: true,
  onMouseEnter: true,
  onMouseOver: true,
  onMouseLeave: true
};

var FiasSearch =
/** @class */
function (_super) {
  __extends(FiasSearch, _super);

  function FiasSearch() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderItem = function (address) {
      return address.getText();
    };

    _this.renderValue = function (address) {
      return address.getText();
    };

    _this.renderNotFound = function () {
      return _this.locale.searchNotFound;
    };

    _this.valueToString = function (address) {
      return address.getText();
    };

    _this.onValueChange = function (address) {
      var onValueChange = _this.props.onValueChange;

      if (onValueChange) {
        onValueChange(address);
      }
    };

    _this.onUnexpectedInput = function (query) {
      if (!query) {
        return new FiasAddress();
      }
    };

    _this.getItems = function (searchText) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, api, limit, options;

        return __generator(this, function (_b) {
          _a = this.props, api = _a.api, limit = _a.limit;
          options = {
            searchText: searchText,
            fullAddress: true,
            directParent: false,
            limit: (limit || FiasSearch_1.defaultProps.limit) + 1 // +1 to detect if there are more items

          };
          return [2
          /*return*/
          , api.search(options).then(function (result) {
            var success = result.success,
                data = result.data,
                error = result.error;
            return success && data ? Promise.resolve(data.map(function (item) {
              return FiasAddress.createFromResponse(item);
            })) : Promise.reject(error);
          })];
        });
      });
    };

    return _this;
  }

  FiasSearch_1 = FiasSearch;

  FiasSearch.prototype.render = function () {
    var restComboBoxProps = filterProps(this.props, COMBOBOX_PASS_PROPS);
    return React.createElement(FiasComboBox, __assign({
      getItems: this.getItems,
      value: this.props.address,
      renderItem: this.renderItem,
      renderValue: this.renderValue,
      valueToString: this.valueToString,
      onValueChange: this.onValueChange,
      onUnexpectedInput: this.onUnexpectedInput,
      renderNotFound: this.renderNotFound
    }, restComboBoxProps));
  };

  var FiasSearch_1;
  FiasSearch.__KONTUR_REACT_UI__ = 'FiasSearch';
  FiasSearch.defaultProps = {
    width: '100%',
    limit: 5,
    drawArrow: false,
    searchOnFocus: false
  };
  FiasSearch = FiasSearch_1 = __decorate([locale('Fias', FiasLocaleHelper)], FiasSearch);
  return FiasSearch;
}(React.Component);

export { FiasSearch };